import {ENV_FLAGS} from './constants';

type EnvFlagType = (typeof ENV_FLAGS)[number];

export type FeatureFlags = {
  [key in EnvFlagType]?: boolean;
};

export const isEnvFlagType = (key: string): key is EnvFlagType =>
  ENV_FLAGS.some(flag => flag == key);
